import useCustomer from "../../hooks/customer/useCustomer";
import EditIcon from "../../assets/icons/edit-icon.png";
import DeleteIcon from "../../assets/icons/delete-icon.png";
import plusIcon from "../../assets/icons/plus-icon.png";
import CustomerModal from "./customer-modal";
import AlertMessage from "../../components/AlertMessage";
import Breadcrumb from "../../components/Breadcrumb";
import Table from "../../components/Table/Table.jsx";

const Customer = () => {
  const {
    loading,
    displayCustomers,
    customer,
    showModal,
    setShowModal,
    onSave,
    onEditClick,
    message,
    showMessage,
    setShowMessage,
  } = useCustomer();
  const columns = [
    { header: "First Name", accessor: "firstName" },
    { header: "Last Name", accessor: "lastName" },
    { header: "Email", accessor: "email" },
    { header: "Phone", accessor: "phoneNumber" },
    {
      header: "Actions",
      render: (row, { onEdit, onDelete }) => (
        <>
          <button className="btn btn-edit " onClick={() => onEdit(row.id)}>
            <img src={EditIcon} />
          </button>
          <button className="btn btn-delete" onClick={() => onDelete(row)}>
            <img src={DeleteIcon} />
          </button>
        </>
      ),
    },
  ];
  if (loading) return <h2>Loading....</h2>;
  return (
    <div className="content">
      <div className="content-block">
        <Breadcrumb parent="Customers" child="All Customers" />
        {showMessage && (
          <AlertMessage
            key={message.text}
            setVisible={setShowMessage}
            message={message.text}
            type={message.type}
            duration={4000}
          />
        )}
        <CustomerModal
          isOpen={showModal}
          customer={customer}
          onSave={onSave}
          onClose={() => setShowModal(false)}
        />

        <Table
          columns={columns}
          data={displayCustomers}
          onDelete={() => {}}
          onEdit={onEditClick}
          onAddClick={setShowModal}
          title={"All Customers"}
        />
      </div>
    </div>
  );
};

export default Customer;
